export const getPostcodeObscured = (postcode: string): string | undefined =>
  postcode.match(/[A-Z]{1,2}[0-9][A-Z0-9]?(?=(?:\s*[A-Z0-9]{3})?$)/)?.[0];
